<template>
	<h1>
		这是404
	</h1>
</template>

<script>
export default{
	name:'NotFound'
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/NotFound.vue